import { api } from '..'

export const assignAlertRuleToDevice =
  (deviceId: string, alertRuleId: string) => () =>
    api.post(`/v1/devices/${deviceId}/alert-rules`, {
      alertRulesId: [alertRuleId],
    })
